import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/my/documents',
}).lazy(() => import('./documents.lazy').then((d) => d.Route))
